'use strict';

require('./cn-distribution-bar.scss');

module.exports = {
  template: require('./cn-distribution-bar.html')
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-distribution-bar/index.js
 ** module id = 61
 ** module chunks = 0
 **/